import React, { useContext, useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import moment from 'moment';
import { FirebaseContext } from '../../context/FirebaseContext';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { Table, Tbody, Td, Th, Thead, Tr, useSortableData } from '../../NecttosComp/Table/Table';
import Input2 from '../../NecttosComp/Input/Input2';
import { getAxiosInstance, getAxiosTokenInstance } from '../../utils/axiosInstance';
import { getAllMinor } from '../../NecttosComp/APICaller/ApiServices';

const getCollegeDetails = async ({ queryKey }: any) => {
	const [, collegeId] = queryKey;
	const instance = await getAxiosInstance();
	const { data } = await instance.get('/college/admissionProcess/getCollegeDetails', {
		params: { collegeId },
	});
	if (data?.statusCode === 200) return data.collegeData;
	throw new Error(data?.message || 'Failed to fetch college details.');
};

function RealTimeAllotment({ onClose }: { onClose: () => void }) {
	const { collegeId } = useContext(FirebaseContext);
	const [tableData, setTableData] = useState<any>([]);
	const [statistics, setStatistics] = useState<any>([]);
	const [type, setType] = useState('');
	const [allotmentState, setAllotmentState] = useState('');
	const [batchName, setBatchName] = useState('');
	const [semester, setSemester] = useState('');
	const [date, setDate] = useState('--:--');
	const [loading, setLoading] = useState(false);
	const [modal, setModal] = useState<any>(false);
	  const [currentStep, setCurrentStep] = useState(-1);
	const ref = useRef<any>(null);

	const allotmentStages = [
		{ id: '0', title: 'Trial Allotment' },
		{ id: 1, title: 'First Allotment' },
		{ id: 2, title: 'Second Allotment' },
		{ id: 3, title: 'Third Allotment' },
		{ id: 4, title: 'Final Allotment' },
		{ id: 5, title: 'Supplementary Allotment' },
		{ id: 6, title: 'Special Allotment' },
		{ id: 7, title: 'Reallotment' },
		{ id: 8, title: 'Spot Allotment' },
		{ id: 9, title: 'Management Allotment' },
		{ id: 10, title: 'Community Allotment' },
	];



const steps = [
  "Initializing verification prerequisites",
  "Retrieving student enrollment data",
  "Retrieving available subject data",
  "Analyzing student preference selections",
  "Indexing and mapping subjects to students",
  "Validating critical rules and conditions",
  "Structuring optimized verification matrix",
  "Preparing system environment",
  "Running first-level verification",
  "Running second-level verification",
  "Running third-level verification",
  "Detecting and resolving allocation conflicts",
  "Validating eligibility and exception cases",
  "Rechecking priority mismatches across students",
  "Finalizing verified subject-student mappings",
  "Storing verified records to the database",
  "Publishing outcomes to student dashboards",
  "Performing final system integrity checks"
];




const fetchAutoIndex = async () => {
	setLoading(true);

	const simulatePromise = simulateSteps(); 

	const instance = await getAxiosTokenInstance();

	try {
		const resp = await instance.post('/college/fyugp/getRealTimeAllotmentFYUGP', {
			collegeId, type, semester, batchName, allotmentState,
		});

		if (resp.data.statusCode === 200) {
			console.log('Allotment completed.');
		} else {
			console.error('Allotment failed:', resp.data.message);
		}
	} catch (error) {
		console.error('API Error:', error);
	} finally {
		await simulatePromise; 
		setLoading(false);
	}
};

const simulateSteps = async () => {
	for (let i = 0; i < steps.length; i++) {
		setCurrentStep(i);
		await new Promise((res) => setTimeout(res, 1000));
	}
};





	const { data = {} } = useQuery(['getAllMinor', batchName, semester], () =>
		getAllMinor(collegeId, null, null, batchName, semester)
	);

    const subjectList = (data as any)?.list || [];


	const { data: collegeData } = useQuery(['collegeData', collegeId], getCollegeDetails);

	const { tableItems, requestSort, getIcon } = useSortableData(tableData);



	
const fetchRealTimeAllotment2 = async () => {
		const instance = await getAxiosTokenInstance();
		const resp = await instance.get('/college/fyugp/getRealTimeAllotmentFYUGP2', {
			params: { collegeId, type, semester, batchName, allotmentState },
		});
		if (resp.data.statusCode !== 200) throw new Error(resp.data.message || 'API Error');

		const { list = [], statistics = [] } = resp.data;
		if (list.length) setTableData(list);
		setStatistics(statistics);
		setDate(moment().format('HH:mm:ss'));
	};
	useEffect(() => {
		if (type || allotmentState || semester || batchName) fetchRealTimeAllotment2();
	}, [type, allotmentState, semester, batchName]);

	return (
		<Main title={`FYUGP : ${tableItems?.length}`} height='100%' width='100%'>
			<Header>
				<div className='flex'>
					<Input2 fieldName='Filter by Type' state={type} setState={setType} className='w-[20vh]' options={['DSC_B', 'DSC_C', 'MDC', 'OpenCourse', 'AEC_OL']} type='drop' />
					<Input2 width='12vw' fieldName='Filter by Semester' state={semester} setState={setSemester} options={['Semester 1', 'Semester 2', 'Semester 3', 'Semester 4', 'Semester 5', 'Semester 6', 'Semester 7', 'Semester 8']} type='drop' className='w-[13vw]' />
					<Input2 width='12vw' fieldName='Batch Name *' state={batchName} setState={setBatchName} options={['2024-2028', '2025-2029', '2025-2027', '2024-2026', '2023-2025', '2023-2026', '2022-2025', '2024-2027', '2024-2029']} type='drop' className='w-[13vw]' />
					<Input2 width='32vw' fieldName='Select Allotment *' state={allotmentState} didntShowKey setState={setAllotmentState} optionDisplay='title' optionKey='id' options={allotmentStages} type='drop' className='w-[25vw]' />
				</div>
				<div className='flex'>
					<Button type='save' onClick={()=>{setModal(true)}}>Take Alotment</Button>
					<Button fileName={`${tableItems?.[0]?.departmentName?.slice(13)}_${type?.toUpperCase()}_${tableItems?.[0]?.subjectName}`} type='print' tableRef={ref.current}>Print</Button>
					<Button type='close' onClick={onClose}>Close</Button>
				</div>
			</Header>

			<Body>
				<div ref={ref} className='printable overflow-auto p-[10%] flex justify-center items-center'>
					<div className='bg-white m-68 w-[50%]'>
						<Table width='100%' innerWidth={['25%', '45%', '30%']}>
							<table className='min-w-full table-auto'>
								<thead>
									<tr>
										<td className='p-1 dark:bg-[#242424]' style={{ width: '70%', fontFamily: 'Times New Roman' }}>
											<img src={collegeData?.dashBoardLink} alt='College Logo' className='h-[100px] w-auto mx-auto' />
										</td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className='p-1 text-center text-slate-900 dark:text-slate-50 dark:bg-slate-950 text-xl font-bold' style={{ width: '70%', fontFamily: 'Times New Roman' }}>
											Allotment Metrics
										</td>
									</tr>
								</tbody>
							</table>

							<Thead>
								<Tr>
									<Th position={0} fontSize='30px' onClick={() => requestSort('name')} icon={getIcon('name')}>Priority</Th>
									<Th textAlign='center' fontSize='30px' position={1} onClick={() => requestSort('rank')} icon={getIcon('rank')}>Count</Th>
									<Th textAlign='center' fontSize='30px' position={2} onClick={() => requestSort('index')} icon={getIcon('index')}>Grievance</Th>
								</Tr>
							</Thead>

							<Tbody height='auto'>
								{statistics?.map((x: any, i: number) => (
									<Tr key={i}>
										<Td index={i} fontSize='30px' position={0}>{x?.title}</Td>
										<Td textAlign='center' fontSize='30px' index={i} position={1}>{x?.count}</Td>
										<Td textAlign='left' fontSize='30px' index={i} position={2}>--</Td>
									</Tr>
								))}
							</Tbody>

							<table className='min-w-full table-auto'>
								<tbody>
									<tr>
										<td className='p-6 text-right text-slate-950 dark:text-white dark:bg-slate-950 text-xl font-bold' style={{ width: '70%', fontFamily: 'Times New Roman' }}>
											Signature
										</td>
									</tr>
								</tbody>
							</table>
						</Table>
					</div>
				</div>
			</Body>
				{modal &&
							<Main width='auto' height='auto' bgColor='white' title="Processing Allocation">
			
								<div className="bg-gray-500 px-6 py-4 flex justify-between items-center">
									<h2 className="text-xl font-bold text-white">Processing Allotment</h2>
									<button
										onClick={() => setModal(false)}
										className="text-white hover:text-gray-200 focus:outline-none"
									>
										<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
											<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
										</svg>
									</button>
								</div>
			
								<div className="p-6 space-y-4">
									<p className="text-gray-700">
										You are allocating subjects for batch <span className="font-semibold">{batchName}</span>, semester <span className="font-semibold">{semester}</span>, and types <span className="font-semibold">{type} - {allotmentState}</span>.
									</p>
			
									<Button type="save" onClick={fetchAutoIndex} disabled={loading}>
										{loading ? 'Processing...' : 'Start Processing of Allocation'}
									</Button>
			
									{loading && (
										<>
											<p className="text-gray-600">Please review filters before proceeding. The process is running:</p>
											<div className="space-y-2">
												{steps.map((step, index) => (
													<div key={index} className="flex items-center space-x-2">
														{index < currentStep ? (
															<svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
																<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
															</svg>
														) : index === currentStep ? (
															<svg className="w-5 h-5 text-yellow-500 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
																<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
															</svg>
														) : (
															<svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
																<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
															</svg>
														)}
														<span className={index === currentStep ? "font-medium text-blue-600" : ""}>{step}</span>
													</div>
												))}
											</div>
										</>
									)}
			
									{currentStep === steps.length - 1 && !loading && (
										<div className="text-green-600 font-semibold pt-4">All tasks completed successfully.</div>
									)}
			
									<div className="flex justify-end space-x-4 pt-4 border-t border-gray-200">
										<button
											onClick={() => setModal(false)}
											className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
										>
											Close
										</button>
									</div>
								</div>
			
			
							</Main>
						}
		</Main>
	);
}

export default RealTimeAllotment;
